import React, { useEffect, useState } from "react";
import HeaderBanner from "./HeaderBanner";
import ShareOptionContainer from "./ShareOptionsContainer";
import MyRefralSection from "./MyRefralSection";
import HowDoesItWork from "./HowDoesItWork";
import TermsAndCondition from "./TermsAndCondition";
import styles from './ReferEarnPage.module.scss'
import { convertToModule } from "factory/utils/clientUtils";
import HK from "factory/modules/HK";
import { withRouter } from "next/router";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { isLoginPopupAction } from "components/common/login/action";
import { pageTypeAction } from "components/pageTypeAction";
import config from "factory/modules/config";
import UniversalAnalytics from "factory/modules/UniversalAnalytics";

const ReferEarnPage = (props) => {
    const [pgBanner, setPgBanner] = useState(null);
    const [DidYouKnowData, setDidYouKnowData] = useState(null);
    const [didYouKnowList, setDidYouKnowList] = useState(null);
    const [myRefralSection, setMyRefralSection] = useState(null);
    const [referData, setReferData] = useState(null)

    useEffect(() => {
        _RouterInit();
    }, []);

    useEffect(() => {
        if (props._isLoggedin) {
            getReferEarnData()
        }
    }, [props._isLoggedin])

    const getPageDetails = (pgSections) => {
        pgSections.map(eachSections => {
            if (eachSections.pgDesignTyp === config.PAGE_SECTION_DESIGN_TYPE.REFER_BENNER && eachSections.type === config.PAGE_SECTION_TYPE.REFER_BENNER) {
                setPgBanner(eachSections.scItms)
            } if (eachSections.pgDesignTyp === config.PAGE_SECTION_DESIGN_TYPE.DID_YOU_KNOW && eachSections.type === config.PAGE_SECTION_TYPE.PAGE_SECTION_WITHOUT_ITEMS) {
                setDidYouKnowData(eachSections)
            } if (eachSections.pgDesignTyp === config.PAGE_SECTION_DESIGN_TYPE.MY_REFRAL && eachSections.type === config.PAGE_SECTION_TYPE.MY_REFRAL) {
                setMyRefralSection(eachSections)
            } if (eachSections.pgDesignTyp === config.PAGE_SECTION_DESIGN_TYPE.DID_YOU_KNOW && eachSections.type === config.PAGE_SECTION_TYPE.DID_YOU_KNOW) {
                setDidYouKnowList(eachSections.scContent);
            }
        })
    }

    const _RouterInit = () => {
        const pageURL = config.APIS.pageData + 'hkLoyaltyBenefitsThirdPartyCoupon?thirdPartyCouponCompanyPrefix=referearn';
        HK.loader(true)
        HK.ajaxCall({ method: 'get', url: pageURL }).then(res => {
            const _res = res && res.data && res.data.results;
            if (_res && !_res.exception) {
                if (_res.page && _res.page.pgSections) {
                    getPageDetails(_res.page.pgSections)
                }
            } else {
                console.log('exception in refer earn page');
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            HK.loader(false)
        })
    }

    const getReferEarnData = () => {
        const pageURL = config.APIS.userFlow.referEarnPage;
        HK.loader(true)
        HK.ajaxCall({ method: 'get', url: pageURL }).then(res => {
            const _res = res && res.data && res.data.results;
            if (_res && !_res.exception) {
                setReferData(_res)
            } else {
                console.log('exception in refer earn page');
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            HK.loader(false)
        })
    }
    const handleUpdateEvent = (data) => {
        let eventData = {
            event_name: 'select_promotion',
            ...data
        }
        UniversalAnalytics.refer_and_earn(eventData);
    }
    const receiveCallback = (data) => {
        handleUpdateEvent(data);
    }

    return (
        <div className={convertToModule(styles, "refer-and-earn-cntnr")}>
            {
                pgBanner && pgBanner.length > 0 ?
                    <HeaderBanner {...props} pgBanner={pgBanner} />
                    : <></>
            }
            {
                props.isMobile ?
                    <>
                        {
                            DidYouKnowData ?
                                <ShareOptionContainer {...props} DidYouKnowData ={DidYouKnowData} referData={referData} handleCallBack={receiveCallback} promotion_name='Did you know' creative_slot={1}/>
                                : <></>
                        }
                        {
                            myRefralSection && HK.loggedIn() && referData ?
                                <MyRefralSection {...props} myRefralSection={myRefralSection} referData={referData} handleCallBack={receiveCallback} promotion_name='My Referrals' creative_slot={2} />
                                : <></>
                        }
                        {
                            didYouKnowList ?
                                <HowDoesItWork {...props} didYouKnowList={didYouKnowList} handleCallBack={receiveCallback} promotion_name='How it owrks' creative_slot={3} referData={{
                                    tbAvailablePoints: referData && referData.tbAvailablePoints || 0,
                                    tbTotalPoints: referData && referData.tbTotalPoints || 0,

                                }} />
                                : <></>
                        }
                        {
                            didYouKnowList ?
                                <TermsAndCondition {...props} didYouKnowList={didYouKnowList} handleCallBack={receiveCallback} promotion_name='Terms and Conditioms' creative_slot={4} referData={{
                                    tbAvailablePoints: referData && referData.tbAvailablePoints || 0,
                                    tbTotalPoints: referData && referData.tbTotalPoints || 0,

                                }} />
                                : <></>
                        }
                    </>
                    :
                    <div className={convertToModule(styles, "refer-and-earn-cntnr-desk")}>
                        {
                            DidYouKnowData ?
                                <ShareOptionContainer referData={referData} DidYouKnowData ={DidYouKnowData} handleCallBack={receiveCallback} promotion_name='Did you know' creative_slot={1}/>
                                : <></>
                        }
                        <div className={convertToModule(styles, "refer-and-earn-cntnr-left")}>
                            {
                                myRefralSection && HK.loggedIn() && referData ?
                                    <MyRefralSection {...props} myRefralSection={myRefralSection} referData={referData} handleCallBack={receiveCallback} promotion_name='My Referrals' creative_slot={2} />
                                    : <></>
                            }
                            {
                                didYouKnowList ?
                                    <HowDoesItWork {...props} didYouKnowList={didYouKnowList} handleCallBack={receiveCallback} promotion_name='How it owrks' creative_slot={3} referral_earned_cash={referData && referData.tbAvailablePoints || 0} referData={{
                                        tbAvailablePoints: referData && referData.tbAvailablePoints || 0,
                                        tbTotalPoints: referData && referData.tbTotalPoints || 0,

                                    }} />
                                    : <></>
                            }
                            {
                                didYouKnowList ?
                                    <TermsAndCondition {...props} didYouKnowList={didYouKnowList} handleCallBack={receiveCallback} promotion_name='Terms and Conditioms' creative_slot={4} referral_earned_cash={referData && referData.tbAvailablePoints || 0} referData={{
                                        tbAvailablePoints: referData && referData.tbAvailablePoints || 0,
                                        tbTotalPoints: referData && referData.tbTotalPoints || 0,

                                    }} />
                                    : <></>
                            }
                        </div>
                    </div>
            }
        </div>
    )

}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        _isLoginPopupAction: isLoginPopupAction,
        _pageTypeAction: pageTypeAction
    }, dispatch);
}
function mapStateToProps(state) {
    return {
        _isLoginPopupReducer: state.isLoginPopupReducer,
        _isLoggedin: state.isLogedInReducer,
        _showAddressFormReducer: state.showAddressFormReducer
    };
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ReferEarnPage)
);
